import type { Outcome } from "@landing/types"

export function isOutcomeClickable(outcome: Outcome, heldOutcomes: string[]): boolean {
  const isHeldEliminatedTeam = outcome.state === "eliminated" && heldOutcomes.includes(outcome.slug)
  return outcome.state !== "eliminated" || isHeldEliminatedTeam
}

export function isOutcomeEliminated(outcome: Outcome, heldOutcomes: string[]): boolean {
  return outcome.state === "eliminated" && !heldOutcomes.includes(outcome.slug)
}

// Get outcome price display (unused but kept for future use)
// function getOutcomePriceDisplay(price: string | number): { display: string; isLessThanOne: boolean } {
//   const numPrice = typeof price === "string" ? Number.parseFloat(price) : price
//
//   if (numPrice === 0) {
//     return { display: "0", isLessThanOne: false }
//   }
//
//   if (numPrice < 1) {
//     const formatted = numPrice.toFixed(2)
//     return { display: formatted.substring(1), isLessThanOne: true }
//   }
//
//   return { display: numPrice.toFixed(2), isLessThanOne: false }
// }

export function getOutcomeBackgroundColor(outcome: Outcome, heldOutcomes: string[]): string {
  if (!outcome.imageSrc?.startsWith("http")) {
    return outcome.imageSrc || "rgba(255, 255, 255, 1)"
  }

  if (!outcome.primaryColor) {
    return "rgba(12, 35, 64, 1)"
  }

  if (isOutcomeEliminated(outcome, heldOutcomes)) {
    return `${outcome.primaryColor}80`
  }

  return outcome.primaryColor
}

export function getOutcomeOpacity(outcome: Outcome, isSelected: boolean, heldOutcomes: string[]): number {
  if (isSelected) return 0.75
  if (isOutcomeEliminated(outcome, heldOutcomes)) return 0.3
  return 0.62
}
